import React from 'react';

interface GradientBackgroundProps {
  /**
   * Children to render over the gradient
   */
  children?: React.ReactNode;
  /**
   * Gradient angle in degrees
   * @default 135
   */
  angle?: number;
}

/**
 * Atom: Reusable gradient background box
 * Inverse-surface tokens (mode-locked) keep white text readable in both
 * light and dark mode — amber rides as the accent elsewhere.
 */
export const GradientBackground: React.FC<GradientBackgroundProps> = ({
  children,
  angle = 160,
}) => {
  return (
    <div
      className="relative flex w-full items-center justify-center"
      style={{
        height: '100%',
        // Dark inverse dominant — white text stays readable throughout
        background: `linear-gradient(${angle}deg, var(--color-surface-inverse-active) 0%, var(--color-surface-inverse) 60%, var(--color-surface-inverse-hover) 100%)`,
      }}
    >
      {children}
    </div>
  );
};
